import sloganImg from "./assets/slogan-img.png";
import quemSomosCharacter from "./assets/quem-somos-character.png";
import quemSomosImg from "./assets/quem-somos-img.png";
import objetivosImg from "./assets/objetivos-img.png";
import nossosParceirosImg from "./assets/nossos-parceiros-img.png";

import "./landing-page.scss";
import Nav from "../../components/nav";
import { useMediaQuery } from "@mui/material";
import { useGlobalState } from "../../global-state-context";

function LandingPage({ nav }: { nav?: React.ReactNode }): JSX.Element {
  const globalState = useGlobalState();
  const isMobile = useMediaQuery("(max-width:600px)");

  if (!globalState) return <></>;

  return (
    <div className="landing-page-container">
      {/* O NAV E INJETAVEL desde o PL-T2.1, e a razao e o T2.2.
          Esta pagina e a versao CLASSICA, e ela e renderizada por duas rotas: `/` no passado, e
          `/classico` hoje. Enquanto ela usava o `<Nav/>` moderno, cada link de dentro dela levava
          para uma tela moderna — que e a queixa na letra: "tudo continua na mesma ideia da
          aplicacao normal". Com o nav injetado, a rota classica recebe o menu classico. */}
      {nav ?? <Nav />}

      <div className="slogan-container">
        <div className="title-container">
          <h1 className="text-shadow">HQ-LAB</h1>
          <h3>Sua plataforma lúdica de aprendizado</h3>
        </div>

        <img src={sloganImg} alt="HQ-LAB" draggable="false" />
      </div>

      <div id="quem-somos" className="quem-somos-container">
        <h1 className="text-shadow">QUEM SOMOS</h1>

        <div className="content-container">
          <img
            className="character-img"
            src={quemSomosCharacter}
            alt="Quem Somos"
            draggable="false"
          />
          <img
            className="bottom-img"
            src={quemSomosImg}
            alt="Quem Somos"
            draggable="false"
          />

          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              flexDirection: "column",
            }}
          >
            <span
              style={{
                textAlign: isMobile ? "left" : "end",
                width: isMobile ? "95%" : "90%",
                marginRight: "2vw",
                fontSize: isMobile ? "15px" : "1.5vw",
              }}
            >
              Somos o Grupo de Pesquisa Geotecnologias, Educação e
              Contemporaneidade, carinhosamente chamado de GEOTEC, cadastrado no
              CNPQ pela Universidade do Estado da Bahia (UNEB).
            </span>

            <span
              style={{
                textAlign: isMobile ? "left" : "end",
                width: isMobile ? "95%" : "82%",
                marginRight: "2vw",
                fontSize: isMobile ? "15px" : "1.5vw",
              }}
            >
              Estamos em parceria com os Programas de Pós-Graduação Educação e
              Contemporaneidade (PPGEDUC) e Gestão e Tecnologias Aplicadas à
              Educação (GESTEC), buscando criar uma ponte entre a UNEB, as
              Escolas Municipais, Estaduais e a comunidade.
            </span>

            <span
              style={{
                textAlign: "justify",
                width: isMobile ? "95%" : "80%",
                marginRight: isMobile ? "2vw" : "8vw",
                fontSize: isMobile ? "15px" : "1.5vw",
              }}
            >
              Nosso projeto "Guarda-chuva" abriga iniciativas incríveis como A
              Rádio da Escola na Escola da Rádio, Redepub e o K-lab, todos com o
              propósito de impulsionar a qualidade da educação pública.
            </span>

            <span
              style={{
                textAlign: "left",
                width: isMobile ? "95%" : "77%",
                alignSelf: "flex-start",
                marginLeft: isMobile ? "2vw" : "9.3vw",
                fontSize: isMobile ? "15px" : "1.5vw",
              }}
            >
              Focando no K-Lab, iniciamos em 2020 o emocionante projeto
              "História em Quadrinhos (HQ) na perspectiva dos processos
              educacionais e tecnológicos como recurso pedagógico em sala de
              aula". Com pesquisadores especializados em diversas áreas, como
              pedagogia, matemática, geografia, história, letras, artes, ciência
              da computação, design, publicidade, entre outras, buscamos mudar a
              forma como encaramos o aprendizado, incentivando a colaboração
              entre disciplinas.
            </span>

            <span
              style={{
                textAlign: "left",
                width: isMobile ? "95%" : "80%",
                alignSelf: "flex-start",
                marginLeft: isMobile ? "2vw" : "9.3vw",
                fontSize: isMobile ? "15px" : "1.5vw",
                marginBottom: "0px",
              }}
            >
              O HQ-Lab vai além da criação de HQs, proporcionando uma
              compreensão profunda e
            </span>
            <span
              style={{
                textAlign: "left",
                width: isMobile ? "95%" : "80%",
                alignSelf: "flex-start",
                marginLeft: isMobile ? "2vw" : "2vw",
                fontSize: isMobile ? "15px" : "1.5vw",
                marginTop: "0px",
              }}
            >
              contextualizada do processo de aprendizado, onde os estudantes são
              os protagonistas da construção do conhecimento. Utilizamos a
              inteligência artificial (IA generativa) para criar uma experiência
              mágica, garantindo eficiência e escalabilidade na geração de
              imagens personalizadas, alinhadas às necessidades educacionais do
              projeto. É a tecnologia a serviço da educação!
            </span>
          </div>
        </div>
      </div>

      <div id="objetivos" className="objetivos-container">
        <div className="title-container">
          <h1 className="text-shadow">Objetivos</h1>
          <img src={objetivosImg} alt="Objetivos" draggable="false" />
        </div>

        <div className="cards-container">
          <div className="objetivo-card">
            <div>01</div>
            <span>
              Ampliar o uso de HQs na educação, aproveitando as tecnologias
              digitais, e incentivar a criatividade dos estudantes e educadores.
            </span>
          </div>
          <div className="objetivo-card">
            <div>02</div>
            <span>
              Dinamizar práticas em sala de aula com HQs aplicadas, destacando
              as potencialidades das Tecnologias na Educação Contemporânea.
            </span>
          </div>
          <div className="objetivo-card">
            <div>03</div>
            <span>
              Promover ações formativas com perspectivas de inovação pedagógica
              e tecnológica, tanto nos espaços escolares quanto não escolares.
            </span>
          </div>
          <div className="objetivo-card">
            <div>04</div>
            <span style={{ marginTop: "1.5vw" }}>
              Difundir os produtos provenientes das experiências entre
              Comunidade, Universidade e Escola, com o objetivo de contribuir
              para a melhoria da qualidade educacional no Estado da Bahia.
            </span>
          </div>
        </div>
      </div>

      <div id="parceiros" className="nossos-parceiros-container">
        <div style={{ position: "relative", zIndex: 2 }}>
          <img
            src={nossosParceirosImg}
            alt="Nossos Parceiros"
            draggable="false"
          />
        </div>

        <h1 className="text-shadow">Nossos Parceiros</h1>

        <div className="board">
          <p>
            A Universidade do Estado da Bahia (UNEB) desempenhou um papel
            essencial na implementação do projeto HQ-Lab, fornecendo apoio
            financeiro por meio do Edital de Nº 033/2022 PROINOVAÇÃO. Esse
            financiamento foi crucial para viabilizar pesquisas, contratação de
            profissionais e aquisição de tecnologias avançadas.{" "}
          </p>
        </div>

        <div className="board">
          <p style={{ width: isMobile ? "90%" : "75%" }}>
            A MVP Consultoria destacou-se como uma entusiasta de inovação e
            tecnologia, e está no centro do desenvolvimento do projeto HQ-Lab.
            Indo além do trabalho de desenvolvedora de software, foi ela quem
            criou a identidade visual da plataforma.{" "}
          </p>

          <p style={{ width: isMobile ? "90%" : "75%" }}>
            Empregando uma consultoria especializada, a MVP concebeu uma
            interface intuitiva e atrativa, integrando tecnologias avançadas de
            inteligência artificial (IA). Essa abordagem inovadora não só
            aprimorou visualmente as HQs, mas também permitiu uma exploração
            criativa ilimitada pelos usuários, potencializando a experiência
            educacional com o uso da IA generativa.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
